import { render, staticRenderFns } from "./PlayerChatBlockLog.vue?vue&type=template&id=6a2f4a49&scoped=true&"
import script from "./PlayerChatBlockLog.vue?vue&type=script&lang=js&"
export * from "./PlayerChatBlockLog.vue?vue&type=script&lang=js&"
import style0 from "./PlayerChatBlockLog.vue?vue&type=style&index=0&id=6a2f4a49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f4a49",
  null
  
)

export default component.exports